import { BlogArticle } from './BlogArticle';

export type { TypeBlogArticleProps } from './types';
export default BlogArticle;
